var map = {
	"./404.png": "./src/assets/404.png",
	"./42f79a2814e888829eda61281fad994.png": "./src/assets/42f79a2814e888829eda61281fad994.png",
	"./48cea2c4874ad07d3871ca66af5dc9e.png": "./src/assets/48cea2c4874ad07d3871ca66af5dc9e.png",
	"./52a99bf440ce82f693c81acf5e58be6.png": "./src/assets/52a99bf440ce82f693c81acf5e58be6.png",
	"./J.png": "./src/assets/J.png",
	"./banner.png": "./src/assets/banner.png",
	"./careListPos.png": "./src/assets/careListPos.png",
	"./checkcode.png": "./src/assets/checkcode.png",
	"./daiban.png": "./src/assets/daiban.png",
	"./doing.png": "./src/assets/doing.png",
	"./duban.png": "./src/assets/duban.png",
	"./guaz.png": "./src/assets/guaz.png",
	"./happy.png": "./src/assets/happy.png",
	"./imgs/commonPage/remind.png": "./src/assets/imgs/commonPage/remind.png",
	"./imgs/school/bell.png": "./src/assets/imgs/school/bell.png",
	"./imgs/school/descend.png": "./src/assets/imgs/school/descend.png",
	"./imgs/school/faceCollectNum.png": "./src/assets/imgs/school/faceCollectNum.png",
	"./imgs/school/guardStuTotal.png": "./src/assets/imgs/school/guardStuTotal.png",
	"./imgs/school/love.png": "./src/assets/imgs/school/love.png",
	"./imgs/school/monthRecord/analyse.png": "./src/assets/imgs/school/monthRecord/analyse.png",
	"./imgs/school/monthRecord/camera.png": "./src/assets/imgs/school/monthRecord/camera.png",
	"./imgs/school/monthRecord/cameraCircle.png": "./src/assets/imgs/school/monthRecord/cameraCircle.png",
	"./imgs/school/monthRecord/care_details.png": "./src/assets/imgs/school/monthRecord/care_details.png",
	"./imgs/school/monthRecord/characterLine.png": "./src/assets/imgs/school/monthRecord/characterLine.png",
	"./imgs/school/monthRecord/checkMark.png": "./src/assets/imgs/school/monthRecord/checkMark.png",
	"./imgs/school/monthRecord/coach.png": "./src/assets/imgs/school/monthRecord/coach.png",
	"./imgs/school/monthRecord/collectCircle.png": "./src/assets/imgs/school/monthRecord/collectCircle.png",
	"./imgs/school/monthRecord/crisisReporting.png": "./src/assets/imgs/school/monthRecord/crisisReporting.png",
	"./imgs/school/monthRecord/dashboard.png": "./src/assets/imgs/school/monthRecord/dashboard.png",
	"./imgs/school/monthRecord/desc.png": "./src/assets/imgs/school/monthRecord/desc.png",
	"./imgs/school/monthRecord/emotion_overview.png": "./src/assets/imgs/school/monthRecord/emotion_overview.png",
	"./imgs/school/monthRecord/exponent.png": "./src/assets/imgs/school/monthRecord/exponent.png",
	"./imgs/school/monthRecord/figure.png": "./src/assets/imgs/school/monthRecord/figure.png",
	"./imgs/school/monthRecord/figureBlue.png": "./src/assets/imgs/school/monthRecord/figureBlue.png",
	"./imgs/school/monthRecord/gradeLeaderAppointment.png": "./src/assets/imgs/school/monthRecord/gradeLeaderAppointment.png",
	"./imgs/school/monthRecord/line.png": "./src/assets/imgs/school/monthRecord/line.png",
	"./imgs/school/monthRecord/love.png": "./src/assets/imgs/school/monthRecord/love.png",
	"./imgs/school/monthRecord/loveRedCircle.png": "./src/assets/imgs/school/monthRecord/loveRedCircle.png",
	"./imgs/school/monthRecord/makeAppointment.png": "./src/assets/imgs/school/monthRecord/makeAppointment.png",
	"./imgs/school/monthRecord/moreThreeTimes.png": "./src/assets/imgs/school/monthRecord/moreThreeTimes.png",
	"./imgs/school/monthRecord/moreTwiceCircle.png": "./src/assets/imgs/school/monthRecord/moreTwiceCircle.png",
	"./imgs/school/monthRecord/panel.png": "./src/assets/imgs/school/monthRecord/panel.png",
	"./imgs/school/monthRecord/parentalAppointment.png": "./src/assets/imgs/school/monthRecord/parentalAppointment.png",
	"./imgs/school/monthRecord/picture.png": "./src/assets/imgs/school/monthRecord/picture.png",
	"./imgs/school/monthRecord/pictureCircle.png": "./src/assets/imgs/school/monthRecord/pictureCircle.png",
	"./imgs/school/monthRecord/processingRate.png": "./src/assets/imgs/school/monthRecord/processingRate.png",
	"./imgs/school/monthRecord/rank.png": "./src/assets/imgs/school/monthRecord/rank.png",
	"./imgs/school/monthRecord/rank1.png": "./src/assets/imgs/school/monthRecord/rank1.png",
	"./imgs/school/monthRecord/rank2.png": "./src/assets/imgs/school/monthRecord/rank2.png",
	"./imgs/school/monthRecord/rank3.png": "./src/assets/imgs/school/monthRecord/rank3.png",
	"./imgs/school/monthRecord/remind.png": "./src/assets/imgs/school/monthRecord/remind.png",
	"./imgs/school/monthRecord/runCircle.png": "./src/assets/imgs/school/monthRecord/runCircle.png",
	"./imgs/school/monthRecord/screenshot.png": "./src/assets/imgs/school/monthRecord/screenshot.png",
	"./imgs/school/monthRecord/smallBellCircle.png": "./src/assets/imgs/school/monthRecord/smallBellCircle.png",
	"./imgs/school/monthRecord/star.png": "./src/assets/imgs/school/monthRecord/star.png",
	"./imgs/school/monthRecord/teacher_management.png": "./src/assets/imgs/school/monthRecord/teacher_management.png",
	"./imgs/school/monthRecord/tinkerBell.png": "./src/assets/imgs/school/monthRecord/tinkerBell.png",
	"./imgs/school/monthRecord/warn.png": "./src/assets/imgs/school/monthRecord/warn.png",
	"./imgs/school/monthRecord/warningMark.png": "./src/assets/imgs/school/monthRecord/warningMark.png",
	"./imgs/school/notCollectNum.png": "./src/assets/imgs/school/notCollectNum.png",
	"./imgs/school/photoCoverRate.png": "./src/assets/imgs/school/photoCoverRate.png",
	"./imgs/school/rise.png": "./src/assets/imgs/school/rise.png",
	"./imgs/school/user.png": "./src/assets/imgs/school/user.png",
	"./login-background.png": "./src/assets/login-background.png",
	"./loginLogo.png": "./src/assets/loginLogo.png",
	"./logo-white.png": "./src/assets/logo-white.png",
	"./logo.png": "./src/assets/logo.png",
	"./logoImg.png": "./src/assets/logoImg.png",
	"./love.png": "./src/assets/love.png",
	"./nodata.png": "./src/assets/nodata.png",
	"./sad.png": "./src/assets/sad.png",
	"./school/icon1.png": "./src/assets/school/icon1.png",
	"./school/icon2.png": "./src/assets/school/icon2.png",
	"./school/icon3.png": "./src/assets/school/icon3.png",
	"./schoolChangeTrend/counselingRecord.png": "./src/assets/schoolChangeTrend/counselingRecord.png",
	"./schoolChangeTrend/dynamic.png": "./src/assets/schoolChangeTrend/dynamic.png",
	"./schoolChangeTrend/dynamicPublishing.png": "./src/assets/schoolChangeTrend/dynamicPublishing.png",
	"./schoolChangeTrend/forewarning.png": "./src/assets/schoolChangeTrend/forewarning.png",
	"./schoolChangeTrend/happy-phiz.png": "./src/assets/schoolChangeTrend/happy-phiz.png",
	"./schoolChangeTrend/interveneIcon.png": "./src/assets/schoolChangeTrend/interveneIcon.png",
	"./schoolChangeTrend/lineChangImg.png": "./src/assets/schoolChangeTrend/lineChangImg.png",
	"./schoolChangeTrend/mood.png": "./src/assets/schoolChangeTrend/mood.png",
	"./schoolChangeTrend/more-event.png": "./src/assets/schoolChangeTrend/more-event.png",
	"./schoolChangeTrend/moreEvent.png": "./src/assets/schoolChangeTrend/moreEvent.png",
	"./schoolChangeTrend/normal-phiz.png": "./src/assets/schoolChangeTrend/normal-phiz.png",
	"./schoolChangeTrend/overview.png": "./src/assets/schoolChangeTrend/overview.png",
	"./schoolChangeTrend/position-icon.png": "./src/assets/schoolChangeTrend/position-icon.png",
	"./schoolChangeTrend/positionIcon.png": "./src/assets/schoolChangeTrend/positionIcon.png",
	"./schoolChangeTrend/psychologyReservation.png": "./src/assets/schoolChangeTrend/psychologyReservation.png",
	"./schoolChangeTrend/rank1.png": "./src/assets/schoolChangeTrend/rank1.png",
	"./schoolChangeTrend/rank2.png": "./src/assets/schoolChangeTrend/rank2.png",
	"./schoolChangeTrend/rank3.png": "./src/assets/schoolChangeTrend/rank3.png",
	"./schoolChangeTrend/unhappy-phiz.png": "./src/assets/schoolChangeTrend/unhappy-phiz.png",
	"./schoolChangeTrend/warn-icon.png": "./src/assets/schoolChangeTrend/warn-icon.png",
	"./schoolChangeTrend/warning-phiz.png": "./src/assets/schoolChangeTrend/warning-phiz.png",
	"./schoolDataScreenbg.png": "./src/assets/schoolDataScreenbg.png",
	"./topicIcon.png": "./src/assets/topicIcon.png",
	"./translate.png": "./src/assets/translate.png",
	"./veryHappy.png": "./src/assets/veryHappy.png",
	"./zaiban.png": "./src/assets/zaiban.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets sync recursive ^\\.\\/.*\\.png$";